<template src="./index.html"></template>
<script>
	import {getdata} from "./data.js";
	import mxdj from "./mxdj/index.vue";
	import uploadFile from "../../../common/uploadFile/index.vue";
	import config from "../../../../../configHttp";
	import {
		hjbhs_init,
		hjbhs_query,
		hjbhs_clearNowTax_api,
		hjbhs_import
	} from "../../../../api/hjbhs.js";
	export default {
		name: "hjbhs",
		components: {
			mxdj,
			uploadFile,
		},
		data: function() {
			return {
				upformdata:"",
				suosq: this.$getdefultMonth(),
				searchdata: getdata().searchdata,
				searchlist: getdata().searchlist,
				outlist: [],
				headData: getdata().headData,
				pagination: getdata().pagination,
				tableData: [{}],
				shaidiag: false,
				searchdiag: false,
				showmxdj: false,
				hzdiag: false,
				detailType:'',
				diagData: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
				czData: [{}, {}, {}],
				fcData: [{}, {}, {}],
				uploaddiag: false,
				tablekey: 0,
				overlength: 0,
				fuzjdata: {
					biaosj: []
				},
				swrwzlList: [],
				wrwlbList: [],
				wrwpfljsffList: [],
				datajson: getdata().json,

			};
		},
		mounted() {
		},
		created() {
			this.init();
		},
		methods: {	  geOoverLength(e){
		  this.overlength = e;
		 
	  },
			//导出
			daoculiebiao() {
				let selectVal = this.$refs.tablebox.getSelectionval();
				let params = {
					pageShowListPojo: {}
				};
				if (selectVal.length < 1) {
				  params.pageShowListPojo = JSON.parse(JSON.stringify(this.searchdata));
				  params.pageShowListPojo.page = this.pagination.pageNum;
				  params.pageShowListPojo.size = this.pagination.pageSize;
				} else {
				  let _ids = selectVal.map((item) => item.id);
				  params.ids = _ids;
				}
				params.json = this.datajson;
				let req = {
				  downUrl: config.baseURL + "/env/list/export",
				  typeObj: {
				    toForm: false,
				    fileType: "xlsx",
					  fileName: "环境保护数据"+ this.$timestampToStr(new Date(), "yyyyMMdd"),
				  },
				  params: params,
				};
				this.$downloadcommon(req);
			},

			getuploadparams(e) {
				//获取上传文件流
				this.upformdata = e;
			},
			forupload() {
				if (this.$emptyandnull(this.upformdata.upfile)) {
					this.$message.error("请选择要上传的文件");
					return false;
				}
				let formData = {
          importType: '0',
					detailType:this.detailType,
					file: this.upformdata.upfile,
				};
				hjbhs_import(formData).then((res) => {
					if (res.data.code ==1) {
            if (res.data.data.errorCount > 0) {
              this.fordowloaderr(this.upformdata.filetype , res.data.data.batchNo);
            } else {
              this.$message.success("上传成功");
            }
						this.gethjbhInfo();
						this.uploaddiag = false;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
      fordowloaderr(filetype, batchNo) {
        let params = {
          downUrl: config.baseURL + "/upload-history/downloadErrorFile",
          typeObj: {
            toForm: true,
            fileType:filetype,
						failUrl:this.$winURl
          },
          params: {
            batchNo: batchNo,
          },
        };
        this.$downloadcommon(params);
      },
			daoru(){
				
				this.upformdata="";
				this.uploaddiag=true
				this.$refs["uploadfileRef"].forrefresh();
			},
			fordownloadmb() {
				let params = {
        downUrl: config.baseURL + "/env/dowloadTemplate",
        typeObj: {
						toForm: true,
						fileType: "xlsx",
						failUrl:this.$winURl
					},
					params:{},
      	};
      	this.$downloadcommon(params);
			},
			minxidenji(v) {
				if (v.suosqbz=='2') {
					return;
				}
				this.fuzjdata.biaosj[0] = v;
				this.fuzjdata.suosq = this.suosq;
				this.showmxdj = true;
			},
			//初始化数据
			init() {
				hjbhs_init().then((res) => {
					if (res.data.code != 1) {
						this.$message.error(res.data.msg);
					} else {
						this.swrwzlList = this.sortSlv(res.data.data.swrwzlList)
						this.wrwlbList = this.sortSlv(res.data.data.wrwlbList)
						this.wrwpfljsffList = this.sortSlv(res.data.data.wrwpfljsffList)
						this.searchdata.suosq = this.$getdefultMonth()
						this.gethjbhInfo();
					}
				});
			},
			sortSlv(v) {
				let svlList = new Array();
				for (let i in v) {
					let param = {
						label: i,
						value: v[i]
					}
					svlList.push(param);
				}
				svlList.sort((a, b) => a.value - b.value);
				return svlList;
			},
			//查询
			gethjbhInfo() {
				if (this.suosq == null || this.suosq === undefined) {
					this.$message.info("请选择所属期");
					return;
				}
				//查询数据
				this.searchdata.suosq = this.suosq
				let params = params = JSON.parse(JSON.stringify(this.searchdata));
				params.current = this.pagination.pageNum;
				params.size = this.pagination.pageSize;
				params.sort = "id";
				hjbhs_query(params).then((res) => {
					if (res.data.code == 1) {
						this.pagination.total = res.data.data.total;
						this.pagination.paginationkey++;
						this.tableData = res.data.data.records;
						this.jinyongpd();
					} else {
						this.$message.error(res.data.msg);
						return;
					}
				});
			},
			//按钮禁用判断
			jinyongpd() {
				this.tableData.forEach((res) => {
					res.sfydata = res.ybtsehj ? true : false; //是否有转出数据
					res.sfyshenbao = res.suosqbz == "1" ? true : false; //是否是当前申报期
				});
			},
			//清空数据
			clearData(row) {
				if (!row.sfydata || !row.sfyshenbao) {
					return;
				}
				this.$showConfirm({
					message: "清空数据后当前税款所属期间内的所有数据将清除，是否确认操作？",
				}).then((res) => {
					if (res == "confirm") {
						this.clearNowTax(row);
					}
				});
			},
			clearNowTax(e) {
				let param = {
					id: e.id,
					suosq: e.suosq,
				};
				hjbhs_clearNowTax_api(param).then((res) => {
					if (res.data.code == 1) {
						this.$message.success("清空数据成功");
						this.gethjbhInfo();
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			forback() {
				this.gethjbhInfo();
				this.showmxdj = false;
			},
			sizechange(e) {
				this.pagination.pageSize = e;
				this.gethjbhInfo();
			},
			currentChange(e) {
				this.pagination.pageNum = e;
				this.gethjbhInfo();
			},
			submitSearch() {
				this.pagination.pageNum = 1;
				this.pagination.paginationkey++;
				this.gethjbhInfo();
			},
			// forRefresh() {
			// 	this.pagination.pageNum = 1;
			// 	this.pagination.paginationkey++;
			// },
			forUpdateSearch() {
				this.searchdiag = true;
			},
			closeSearch() {
				this.searchdiag = false;
			},
			saveChange(e) {
				this.searchdiag = false;
			},
			confirmfilter(e) {
				this.headData = e.chooselist;
				this.outlist = e.nochooselist;
				this.shaidiag = false;
			},
			closeshaidiag() {
				this.shaidiag = false;
			},
		},
	};
</script>

<style scoped lang="less">
	@import url("./index.less");
</style>
